import { useState } from "react";
import DirectionalButton from "../../components/DirectionalButton";

function FeaturedProjects({ content }) {
  const projectsPerLoad = 4;
  const [visibleProjects, setVisibleProjects] = useState(projectsPerLoad);
  const hasMoreProjects = visibleProjects < content.projects.length;

  function handleProjectsToggle() {
    if (hasMoreProjects) {
      setVisibleProjects((currentCount) =>
        Math.min(currentCount + projectsPerLoad, content.projects.length),
      );
      return;
    }

    setVisibleProjects(projectsPerLoad);
  }

  return (
    <section className="featured-projects" id="projects">
      <div className="container">
        <p className="eybrow" data-wow="fade-up">
          <img
            className="star-icon"
            src="/assets/images/star.png"
            alt=""
            aria-hidden="true"
          />
          {content.eyebrow}
        </p>
        <h2 className="heading featured-title" data-wow="fade-up">{content.title}</h2>

        <div className="projects-grid">
          {content.projects.slice(0, visibleProjects).map((project) => (
            <a
              className="project-card"
              href="#contact"
              data-bs-toggle="modal"
              data-bs-target="#queryModal"
              key={project.title}
              data-wow="fade-up"
              style={{ "--wow-delay": `${(content.projects.indexOf(project) % 2) * 120}ms` }}
            >
              <div className="project-image-wrap">
                <img
                  className="project-image"
                  src={project.image}
                  alt={project.title}
                />
              </div>
              <p className="project-category">{project.category}</p>
              <p className="title">{project.title}</p>
            </a>
          ))}
        </div>

        <div className="btn-wrapper">
          <DirectionalButton
            as="button"
            type="button"
            onClick={handleProjectsToggle}
          >
            {hasMoreProjects ? content.loadMoreLabel : content.loadLessLabel}{" "}
            <i className="fa-solid fa-arrow-right" />
          </DirectionalButton>
        </div>
      </div>
    </section>
  );
}

export default FeaturedProjects;
